import { render } from "./TopProductsBySales.vue?vue&type=template&id=b3fd4010&scoped=true&ts=true"
import script from "./TopProductsBySales.vue?vue&type=script&lang=ts"
export * from "./TopProductsBySales.vue?vue&type=script&lang=ts"

import "./TopProductsBySales.vue?vue&type=style&index=0&id=b3fd4010&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fd4010"]])

export default __exports__